import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SelectStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  .select__dropdown-indicator {
    display: flex;
  }

  #create_status_filter {
    /* background-color: red;
    min-width: max-content;
    right: 0; */

    .select__menu {
      min-width: max-content;
      right: 0;
    }
  }

  /* .css-26l3qy-menu {

  } */

  /* Modifiers
  ------------------------------- */
  &.table-filter {
    margin-left: 10px;

    &.all-pre-assessment {
      width: 230px;
    }

    &.all-status {
      width: 150px;
      min-width: 150px;
    }
  }

  &.year-established-filter {
    width: 100%;
  }

  /* State
  ------------------------------- */
  &:hover {
    .select__clear-indicator {
      display: flex;
      padding: 8px 0 8px 8px;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .select__control {
      height: 40px;
      min-height: 32px;
    }

    .select__indicators {
      min-height: 38px;
    }

    .select__indicator {
      svg {
        width: 19px;
        height: 19px;
      }
    }

    &.table-filter {
      &.all-pre-assessment {
        width: 220px;
      }

      &.all-status {
        width: 140px;
        min-width: 0;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    min-width: 160px;

    .select__control {
      height: 38px;
    }

    .select__indicators {
      min-height: 36px;
    }

    .select__indicator {
      svg {
        width: 18px;
        height: 18px;
      }
    }

    &.table-filter {
      &.all-pre-assessment {
        width: 210px;
      }

      &.all-status {
        width: 130px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .select__control {
      height: 36px;
    }

    .select__indicators {
      min-height: 34px;
    }

    .select__indicator {
      svg {
        width: 17px;
        height: 17px;
      }
    }

    &.table-filter {
      &.all-pre-assessment {
        width: 200px;
      }

      &.all-status {
        width: 120px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .select__control {
      height: 34px;
    }

    .select__indicators {
      min-height: 32px;
    }

    .select__indicator {
      svg {
        width: 16px;
        height: 16px;
      }
    }

    &.table-filter {
      &.all-pre-assessment {
        width: 180px;
      }

      &.all-status {
        /* width: 110px; */
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .select__control {
      height: 32px;
    }

    .select__indicators {
      min-height: 30px;
    }

    .select__indicator {
      svg {
        width: 15px;
        height: 15px;
      }
    }

    &.table-filter {
      &.all-pre-assessment {
        width: 170px;
      }
    }
  }
`
